/* Outdoer custom filters logic - v3 (moved out of section inline script).
   Fixes: drawer portal to <body> (escapes transformed ancestors), live item count,
   deduped card matching. */
(function () {
  if (window.outdoerFiltersBound) return;
  window.outdoerFiltersBound = true;

  var countEl = null;

  function readParams() {
    var p = new URLSearchParams(location.search);
    return {
      d: (p.get('d') || '').toLowerCase().split(',').filter(Boolean),
      s: (p.get('s') || '').toLowerCase().split(',').filter(Boolean),
      z: (p.get('z') || '').split(',').filter(Boolean),
      c: (p.get('c') || '').split(',').filter(Boolean),
      wmin: p.get('wmin'),
      wmax: p.get('wmax'),
    };
  }

  function writeParams(state) {
    var p = new URLSearchParams(location.search);
    ['d','s','z','c'].forEach(function (k) {
      if (state[k].length === 0) p.delete(k); else p.set(k, state[k].join(','));
    });
    if (state.wmin === null || state.wmin === undefined || state.wmin === '') p.delete('wmin'); else p.set('wmin', state.wmin);
    if (state.wmax === null || state.wmax === undefined || state.wmax === '') p.delete('wmax'); else p.set('wmax', state.wmax);
    history.replaceState(null, '', location.pathname + (p.toString() ? '?' + p.toString() : '') + location.hash);
  }

  function findProductCards() {
    var raw = document.querySelectorAll(
      '.product-grid > *, .product-grid__item, [class*="product-card"], product-card, .resource-list__item'
    );
    var arr = Array.prototype.slice.call(raw);
    // Dedup: keep only outermost elements (drop ones nested inside another match).
    return arr.filter(function (el) {
      return !arr.some(function (other) { return other !== el && other.contains(el); });
    });
  }

  function getCardAttrs(card) {
    var src = card.querySelector('[data-product-tags]') || card;
    var tags = (src.getAttribute('data-product-tags') || '').toLowerCase().split(',').map(function (t) { return t.trim(); });
    var sizes = (src.getAttribute('data-product-sizes') || '').split(',').map(function (t) { return t.trim(); });
    var colors = (src.getAttribute('data-product-colors') || '').split(',').map(function (t) { return t.trim(); });
    return { tags: tags, sizes: sizes, colors: colors };
  }

  function cardMatches(card, state) {
    var attrs = getCardAttrs(card);
    var ok;
    if (state.d.length > 0) {
      ok = state.d.some(function (v) { return attrs.tags.indexOf('dept:' + v) !== -1; });
      if (!ok) return false;
    }
    if (state.s.length > 0) {
      ok = state.s.some(function (v) { return attrs.tags.indexOf('style:' + v) !== -1; });
      if (!ok) return false;
    }
    if (state.z.length > 0) {
      ok = state.z.some(function (v) { return attrs.sizes.indexOf(v) !== -1; });
      if (!ok) return false;
    }
    if (state.c.length > 0) {
      ok = state.c.some(function (v) { return attrs.tags.indexOf('color:' + v) !== -1; });
      if (!ok) return false;
    }
    if (state.wmin || state.wmax) {
      var nums = attrs.sizes.map(function (s) { var n = parseInt(s, 10); return isNaN(n) ? null : n; }).filter(function (n) { return n !== null; });
      if (nums.length === 0) return false;
      var wmin = parseInt(state.wmin || '0', 10);
      var wmax = parseInt(state.wmax || '999', 10);
      var any = nums.some(function (n) { return n >= wmin && n <= wmax; });
      if (!any) return false;
    }
    return true;
  }

  function findCountEl() {
    if (countEl && document.contains(countEl)) return countEl;
    var els = document.querySelectorAll('span, div, p, small, h2');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length === 0 && /^\s*\d+\s+items?\s*$/i.test(el.textContent || '')) { countEl = el; return el; }
    }
    return null;
  }

  function applyFilters(state) {
    var cards = findProductCards();
    var visible = 0;
    cards.forEach(function (c) {
      var show = cardMatches(c, state);
      c.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    var ce = findCountEl();
    if (ce && cards.length > 0) ce.textContent = visible + (visible === 1 ? ' item' : ' items');
    var anySelected = state.d.length + state.s.length + state.z.length + state.c.length > 0 || state.wmin || state.wmax;
    var clearBtn = document.querySelector('[data-outdoer-clear]');
    if (clearBtn) clearBtn.hidden = !anySelected;
  }

  var STYLE_TO_DEPT = {
    'skort':'bottoms','skirt':'bottoms','pants':'bottoms','shorts':'bottoms','dress':'bottoms',
    'joggers':'bottoms','trousers':'bottoms','leggings':'bottoms','bike-shorts':'bottoms',
    'tee':'tops','polo':'tops','tank':'tops','sports-bra':'tops','hoodie':'tops','sweatshirt':'tops',
    'sweater':'tops','button-up':'tops','crew':'tops','mock-neck':'tops','quarter-zip':'tops',
    'pullover':'tops','vest':'tops','blouse':'tops',
    'jacket':'outerwear',
    'cap':'hats','hat':'hats','beanie':'hats',
  };

  function syncCheckboxes(state) {
    document.querySelectorAll('[data-outdoer-filters] input[type="checkbox"]').forEach(function (cb) {
      var key = cb.getAttribute('data-filter');
      cb.checked = (state[key] || []).indexOf(cb.value) !== -1;
    });
    syncStyleConstraints(state);
  }

  function syncStyleConstraints(state) {
    var deptSelected = state.d || [];
    document.querySelectorAll('[data-outdoer-filters] input[data-filter="s"]').forEach(function (cb) {
      var styleVal = cb.value;
      var styleDept = STYLE_TO_DEPT[styleVal];
      var allowed = deptSelected.length === 0 || (styleDept && deptSelected.indexOf(styleDept) !== -1);
      var label = cb.closest('label');
      if (allowed) {
        cb.disabled = false;
        if (label) { label.style.opacity = ''; label.style.pointerEvents = ''; label.style.cursor = ''; }
      } else {
        if (cb.checked) {
          cb.checked = false;
          var arr = state.s || [];
          var i = arr.indexOf(styleVal);
          if (i !== -1) { arr.splice(i, 1); state.s = arr; writeParams(state); }
        }
        cb.disabled = true;
        if (label) { label.style.opacity = '0.35'; label.style.pointerEvents = 'none'; label.style.cursor = 'not-allowed'; }
      }
    });
  }

  function setupWaistSlider(state) {
    var minInput = document.querySelector('[data-waist="min"]');
    var maxInput = document.querySelector('[data-waist="max"]');
    if (!minInput || !maxInput) return;
    var minLabel = document.querySelector('[data-waist-min-label]');
    var maxLabel = document.querySelector('[data-waist-max-label]');
    var rangeBar = document.querySelector('[data-waist-range]');
    var totalMin = parseInt(minInput.min, 10);
    var totalMax = parseInt(minInput.max, 10);

    if (state.wmin) minInput.value = state.wmin;
    if (state.wmax) maxInput.value = state.wmax;

    function syncUI() {
      var lo = parseInt(minInput.value, 10);
      var hi = parseInt(maxInput.value, 10);
      if (lo > hi) {
        if (document.activeElement === minInput) { minInput.value = hi; lo = hi; }
        else { maxInput.value = lo; hi = lo; }
      }
      if (minLabel) minLabel.textContent = lo;
      if (maxLabel) maxLabel.textContent = hi;
      if (rangeBar && totalMax > totalMin) {
        var leftPct = ((lo - totalMin) / (totalMax - totalMin)) * 100;
        var widthPct = ((hi - lo) / (totalMax - totalMin)) * 100;
        rangeBar.style.left = leftPct + '%';
        rangeBar.style.width = widthPct + '%';
      }
    }

    function commit() {
      var cur = readParams();
      var lo = parseInt(minInput.value, 10);
      var hi = parseInt(maxInput.value, 10);
      cur.wmin = (lo === totalMin) ? '' : String(lo);
      cur.wmax = (hi === totalMax) ? '' : String(hi);
      writeParams(cur);
      applyFilters(cur);
    }

    minInput.addEventListener('input', syncUI);
    maxInput.addEventListener('input', syncUI);
    minInput.addEventListener('change', commit);
    maxInput.addEventListener('change', commit);

    syncUI();
  }

  function handleChange(e) {
    var cb = e.target.closest('input[type="checkbox"][data-filter]');
    if (!cb || cb.disabled) return;
    var state = readParams();
    var key = cb.getAttribute('data-filter');
    var arr = state[key] || [];
    var v = cb.value;
    var i = arr.indexOf(v);
    if (cb.checked && i === -1) arr.push(v);
    if (!cb.checked && i !== -1) arr.splice(i, 1);
    state[key] = arr;
    writeParams(state);
    if (key === 'd') syncStyleConstraints(state);
    applyFilters(state);
  }

  function handleClear() {
    var empty = { d: [], s: [], z: [], c: [], wmin: '', wmax: '' };
    writeParams(empty);
    syncCheckboxes(empty);
    var minInput = document.querySelector('[data-waist="min"]');
    var maxInput = document.querySelector('[data-waist="max"]');
    if (minInput && maxInput) {
      minInput.value = minInput.min;
      maxInput.value = maxInput.max;
      minInput.dispatchEvent(new Event('input'));
    }
    applyFilters(empty);
  }

  function init() {
    var aside = document.querySelector('[data-outdoer-filters]');
    // Portal the whole filter UI to <body>: position:fixed breaks when any ancestor
    // has transform/filter/backdrop-filter (that's what pushed the drawer off-screen).
    if (aside && aside.parentElement !== document.body) document.body.appendChild(aside);

    var state = readParams();
    syncCheckboxes(state);
    setupWaistSlider(state);
    applyFilters(state);
    document.addEventListener('change', handleChange);
    var clearBtn = document.querySelector('[data-outdoer-clear]');
    if (clearBtn) clearBtn.addEventListener('click', handleClear);
    setTimeout(function () { applyFilters(readParams()); }, 300);
    setTimeout(function () { applyFilters(readParams()); }, 1200);
    setTimeout(function () { applyFilters(readParams()); }, 2500);

    var toggle = document.querySelector('[data-outdoer-toggle]');
    var closeBtn = document.querySelector('[data-outdoer-close]');
    var backdrop = document.querySelector('[data-outdoer-backdrop]');
    function openDrawer() { if (aside) aside.setAttribute('data-open', '1'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { if (aside) aside.removeAttribute('data-open'); document.body.style.overflow = ''; }
    function toggleDrawer() {
      if (aside.hasAttribute('data-open')) closeDrawer(); else openDrawer();
    }
    if (toggle) toggle.addEventListener('click', toggleDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aside && aside.hasAttribute('data-open')) closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
